export default function formatPTCurrency(value) {
  if (typeof value !== 'number') return value;
  const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  return currency.replace(/-/g, '- ');
}



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/shared/CurrencyFormatter.js